async function materialJsonFormsRenderers() {
  const jsonFormsRenderers = await import('./renderers');

  return jsonFormsRenderers.default;
}

export default materialJsonFormsRenderers;
